import { notificationBubbleClasses } from './styles'

export const NotificationBubble = ({ number }) => {
  return <div className={notificationBubbleClasses}>{number}</div>
}
